import React, { useContext, useEffect, useRef, useState } from 'react';
import { Volume2, VolumeX, Play } from 'lucide-react';
import Context from '../../app_context/Context';

const BackgroundMusic = ({ audioUrl }) => {
    const { isPlaying, setIsPlaying, hasInteracted, setHasInteracted } = useContext(Context);

    const audioRef = useRef(null);
    // const [isPlaying, setIsPlaying] = useState(false);
    // const [hasInteracted, setHasInteracted] = useState(false);

    useEffect(() => {
        audioRef.current = new Audio(audioUrl);
        audioRef.current.loop = true;

        // Event listeners
        const handlePlay = () => setIsPlaying(true);
        const handlePause = () => setIsPlaying(false);
        audioRef.current.addEventListener('play', handlePlay);
        audioRef.current.addEventListener('pause', handlePause);

        // Cleanup
        return () => {
            if (audioRef.current) {
                audioRef.current.removeEventListener('play', handlePlay);
                audioRef.current.removeEventListener('pause', handlePause);
                audioRef.current.pause();
                audioRef.current = null;
            }
        };
    }, [audioUrl]);

    const startAudio = async () => {
        try {
            await audioRef.current.play();
            setHasInteracted(true);
        } catch (error) {
            console.log('Playback failed:', error);
        }
    };


    const togglePlay = async () => {
        if (!audioRef.current) return;

        try {
            if (isPlaying) {
                audioRef.current.pause();
            } else {
                await audioRef.current.play();
            }
        } catch (error) {
            console.log('Playback failed:', error);
        }
    };

    if (!hasInteracted) {
        return (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
                onClick={startAudio}
            >
                <button
                    //    onClick={startAudio}
                    className="bg-white/90 hover:bg-white p-6 rounded-full shadow-lg transition-all duration-300 animate-pulse"
                    aria-label="เริ่มเล่นเพลง"
                >
                    <Play className="w-12 h-12 text-gray-800" />
                </button>
            </div>
        );
    }

    return (
        <button
            onClick={togglePlay}
            className="fixed bottom-4 right-4 z-50 p-3 rounded-full bg-white/80 shadow-lg hover:bg-white transition-all duration-300"
            aria-label={isPlaying ? 'ปิดเสียง' : 'เปิดเสียง'}
        >
            {isPlaying ? (
                <Volume2 className="w-6 h-6 text-gray-800" />
            ) : (
                <VolumeX className="w-6 h-6 text-gray-800" />
            )}
        </button>
    );
};

export default BackgroundMusic;